import {
  DotLottieWorker,
  DotLottieWorkerReact,
} from '@lottiefiles/dotlottie-react'
import classNames from 'classnames'
import { FC, ReactNode, useEffect, useMemo, useState } from 'react'

import { useStarAnim } from '../../hooks'
import styles from './GalaxyButton.module.scss'

type GalaxyButtonProps = {
  children: ReactNode
  onClick?: () => void
  className?: string
  withGlow?: boolean
  disabled?: boolean
}

export const GalaxyButton: FC<GalaxyButtonProps> = ({
  children,
  onClick,
  className,
  withGlow = true,
  disabled = false,
}) => {
  const [leftLottieStars, setLeftLottieStars] =
    useState<DotLottieWorker | null>(null)
  const { starAnim } = useStarAnim()

  const renderStarAnim = useMemo(() => {
    if (!starAnim) {
      return null
    }

    return (
      <>
        <DotLottieWorkerReact
          data={starAnim}
          dotLottieRefCallback={setLeftLottieStars}
          loop
          autoplay
          className={classNames(styles.starAnim, styles.starAnimLeft)}
        />
        <DotLottieWorkerReact
          data={starAnim}
          autoplay
          loop
          className={classNames(styles.starAnim, styles.starAnimRight)}
        />
      </>
    )
  },[starAnim])

  useEffect(() => {
    if (!leftLottieStars) return
    leftLottieStars.setFrame(15)
  }, [leftLottieStars])

  return (

      <div
        className={classNames(styles.button, className, {
          [styles.withGlow]: withGlow,
          [styles.disabled]: disabled,
        })}
        onClick={onClick}
      >
        {renderStarAnim}
        {children}
      </div>

  )
}
